enum AccidentDescriptionEnum {
  GLASS_DAMAGE = 'Glasschaden',
  LANE_CHANGE = 'Fahrspurwechsel',
  MARTEN_DAMAGE = 'Marderschaden',
  MISCELLANEOUS = 'Sonstiges',
  NONE = '',
  PARKING_ACCIDENT = 'Parkunfall',
  REAR_END_COLLISION = 'Auffahrunfall',
  RIGHT_OF_WAY_VIOLATION = 'Vorfahrtsverletzung',
  WILDLIFE_ACCIDENT = 'Wildunfall',
}

export default AccidentDescriptionEnum;
